export default __webpack_public_path__ + "static/media/hmd_m1.b4cf4179.png";